<template>
  <svg width="24" height="24" viewBox="0 0 21 20" fill="none" aria-hidden="true">
    <path
      d="M18 10L12 10M18 5L8 5M18 15L12 15M9.16667 10C9.16667 10.4602 8.79357 10.8333 8.33333 10.8333C7.8731 10.8333 7.5 10.4602 7.5 10C7.5 9.53976 7.8731 9.16667 8.33333 9.16667C8.79357 9.16667 9.16667 9.53976 9.16667 10ZM9.16667 15C9.16667 15.4602 8.79357 15.8333 8.33333 15.8333C7.8731 15.8333 7.5 15.4602 7.5 15C7.5 14.5398 7.8731 14.1667 8.33333 14.1667C8.79357 14.1667 9.16667 14.5398 9.16667 15Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M5.79037 3.67222L4.3737 5.89444C4.19277 6.13569 4.1023 6.25631 3.9914 6.29944C3.89425 6.33722 3.78648 6.33722 3.68934 6.29944C3.57843 6.25631 3.48797 6.13569 3.30703 5.89444L1.79037 3.67222"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
